import Chart from 'chart.js/auto'

import annotationPlugin from 'chartjs-plugin-annotation';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';

// Standard Normal variate using Box-Muller transform.
function gaussianRandom(mean=0, stdev=1, min=-Infinity, max=Infinity) {
    const u = 1 - Math.random(); // Converting [0,1) to (0,1]
    const v = Math.random();
    const z = Math.sqrt( -2.0 * Math.log( u ) ) * Math.cos( 2.0 * Math.PI * v );
    // Transform to the desired mean and standard deviation:
    return Math.min(max, Math.max(min, z * stdev + mean));
}

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function shuffleArray(array) {
  let currentIndex = array.length, randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element using array destructuring.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

function formatDateTime(date) {
    const year = date.getFullYear();
    // getMonth() returns 0-11, so add 1
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

(async function() {
    // const rawData = [
    //     { time : '2025-01-01 08:00', systolic: 120, diastolic: 80 },
    //     { time : '2025-01-02 08:00', systolic: 130, diastolic: 85 },
    //     { time : '2025-01-03 08:00', systolic: 125, diastolic: 82 },
    //     { time : '2025-01-03 12:00', systolic: 135, diastolic: 86 },
    //     { time : '2025-01-03 18:00', systolic: 145, diastolic: 87 },
    //     { time : '2025-01-04 08:00', systolic: 140, diastolic: 88 },
    // ];

    let rawData = [];
    const now = new Date();
    for (let ndx = 1000; ndx > 0; ndx--) {
        let d = new Date();
        d.setDate(now.getDate() - ndx);

        let count = getRandomIntInclusive(0, 3);
        let allHours = [6, 8, 12, 15, 18];
        shuffleArray(allHours);
        allHours.slice(0, count).sort((a,b) => a-b).forEach(hour => {
            let seconds = gaussianRandom(3600*hour, 900, 3600*(hour-1), 3600*(hour+1));
            d.setHours(seconds/3600, (seconds%3600)/60, seconds%60);

            let samples = gaussianRandom(1, 1, 1, 3);
            let systolic  = gaussianRandom(130, 10, 100, 170);
            let diastolic = gaussianRandom(90, 5, 50, 140);
            for (let i = 0; i < samples; i++) {
                rawData.push({
                    time: formatDateTime(d),
                    systolic:  Math.floor(gaussianRandom(systolic,  5, 80, 200)),
                    diastolic: Math.floor(gaussianRandom(diastolic, 3, 40, 150)),
                });
                d.setTime(d.getTime() + 1000*gaussianRandom(180, 30, 60, 600));
            }
        })
    }

    const datasets = [
        {
            label: 'Systolic',
            data: rawData.map(raw => { return { x: raw.time, y: raw.systolic }}),
            borderColor: 'red',
            fill: false,
            showLine: false,
        },
        {
            label: 'Diastolic',
            data: rawData.map(raw => { return { x: raw.time, y: raw.diastolic }}),
            borderColor: 'blue',
            fill: false,
            showLine: false,
        },
    ];

    Chart.register(annotationPlugin);
    Chart.register(zoomPlugin);

    new Chart(
        document.getElementById('pressure'),
        {
            type: 'line',
            data: {
                datasets,
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        title: { display: true, text: 'Date' }
                    },
                    y: {
                        title: { display: true, text: 'mmHg' },
                        min: 40,
                        max: 180
                    }
                },

                plugins: {
                    tooltip: {
                        mode: 'index', // Shows all datasets for the hovered index
                        intersect: false
                    },

                    annotation: {
                        annotations: {
                            highSystolic: {
                                type: 'line',
                                yMin: 120,
                                yMax: 120,
                                borderColor: 'rgb(255, 99, 132)',
                                borderWidth: 5,
                            },
                            highDiastolic: {
                                type: 'line',
                                yMin: 80,
                                yMax: 80,
                                borderColor: 'rgb(99, 132, 255)',
                                borderWidth: 5,
                            },
                        }
                    },

                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'x', // Pan horizontally
                        },
                        zoom: {
                            wheel: {
                                enabled: true, // Mouse wheel zoom
                            },
                            pinch: {
                                enabled: true // Pinch gesture zoom
                            },
                            mode: 'x', // Zoom horizontally
                            drag: {
                                enabled: true, // Enable drag-to-zoom
                                backgroundColor: 'rgba(225,225,225,0.3)',
                                modifierKey: 'shift',
                            },
                            limits: {
                                x: {
                                    min: rawData[0].time,
                                    min: rawData[rawData.length-1].time,
                                    minRange: 15*60*1000,
                                },
                            },
                        },
                    },
                },
            }
        }
    );
})();
